import { render, staticRenderFns } from "./photoUpload.vue?vue&type=template&id=24c42ac4&scoped=true&"
import script from "./photoUpload.vue?vue&type=script&lang=js&"
export * from "./photoUpload.vue?vue&type=script&lang=js&"
import style0 from "./photoUpload.vue?vue&type=style&index=0&id=24c42ac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c42ac4",
  null
  
)

export default component.exports